<template>
  <div
    v-if="true"
    class="col-12"
  >
    <div class="row d-flex">
      <div class="col-sm-10 col-12">
        <div class="row">
          <label class="col-sm-2 col-12 col-form-label text-center"> {{ $t('customer.search') }}:</label>
          <input
                  class="form-control col-sm-10 col-12 mb-1"
                  :value="term"
                  :placeholder="$t('customer.searchPlaceholder')"
                  @input="search($event.target.value)"
          >
        </div>

      </div>
      <div class="col-sm-2 col-12 text-center">
        <button
                class="btn btn-sm btn-secondary d-inline-block"
                @click="search('')"
        >
          {{ $t('buttons.clean') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Search',
  props: {
    term: {
      type: String,
      required: true
    }
  },
  methods: {
    search (term) {
      this.$emit('search', term)
    }
  }
};
</script>
